import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoalService } from 'app/services/coal.service';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState } from 'app/store/app.states';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-wiz-done',
  templateUrl: './wiz-done.component.html',
  styleUrls: ['./wiz-done.component.scss']
})
export class WizDoneComponent implements OnInit {
    @Input() opcionSeleccionada: string = 'propia';
    @Input() nuevoUsuarioForm: FormGroup;
    @Input() existingUserId: number | null = null;

    @Output() opcionSeleccionadaChange = new EventEmitter<string>();
    @Output() emailAvailableChange = new EventEmitter<boolean>();
    @Output() existingUserIdChange = new EventEmitter<number | null>();

    usuarioSeleccionado: number | null = null;
    usuariosRegistrados = [];

    emailValidationStarted: boolean = false;
    emailAvailable: boolean | null = null;
    opeCuenta: any;

    constructor(
        private fb: FormBuilder,
        private coalService: CoalService,
        private store: Store<AppState>,
    ) {}

    ngOnInit(): void {
        if (!this.nuevoUsuarioForm) {
            this.nuevoUsuarioForm = this.fb.group({
                nombre: ['', Validators.required],
                email: ['', [Validators.required, Validators.email]],
                contrasena: ['', Validators.required]
            });
        }

        // Suscribirse al estado de Redux para obtener opeCuenta
        this.store.select(selectAuthState).pipe(take(1)).subscribe((state: any) => {
            console.log(state);
            
            this.opeCuenta = state.seguridad.user.opeCuenta; // Aquí obtenemos el opeCuenta
            // Ahora puedes usar opeCuenta según lo necesites en tu componente
            console.log('opeCuenta obtenido de Redux:', this.opeCuenta);
        });
    }

    seleccionarOpcion(opcion: string) {
        this.opcionSeleccionada = opcion;
        this.opcionSeleccionadaChange.emit(this.opcionSeleccionada);
    
        if (opcion === 'existente') {
            this.getUniqueUsersFromCuentas().then((usuarios) => {
                this.usuariosRegistrados = usuarios;
            }).catch(error => {
                console.error('Error al obtener los usuarios:', error);
                this.usuariosRegistrados = [];
            });
        }
    }

    seleccionarUsuario(id: number) {
        this.usuarioSeleccionado = id;
        this.existingUserId = id;
        this.existingUserIdChange.emit(this.existingUserId);
    }

    guardarGestion() {
        if (this.opcionSeleccionada === 'propia') {
            console.log('El usuario gestionará la cuenta.');
        } else if (this.opcionSeleccionada === 'existente') {
            console.log('Usuario seleccionado:', this.usuarioSeleccionado);
        } else if (this.opcionSeleccionada === 'nuevo') {
            console.log('Nuevo usuario:', this.nuevoUsuarioForm.value);
        }
    }

    checkEmailRegistered(email: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const query = `users?filters[email][$eq]=${email}`;
            this.coalService.getService(query)
                .subscribe({
                    next: (res: any) => {
                        if (res && res.length > 0) {
                            resolve({ registrado: true, data: res });
                        } else {
                            resolve({ registrado: false });
                        }
                    },
                    error: (error: any) => reject(error)
                });
        });
    }    

    onEmailBlur() {
        const emailControl = this.nuevoUsuarioForm.get('email');
        if (emailControl?.valid) {
            this.checkEmailRegistered(emailControl.value).then(result => {
                this.emailValidationStarted = true;
                this.emailAvailable = !result.registrado;
                this.emailAvailableChange.emit(this.emailAvailable);
            }).catch(error => {
                console.error('Error al verificar el correo:', error);
                this.emailAvailable = null;
                this.emailAvailableChange.emit(null);
            });
        }
    }
    
    getUniqueUsersFromCuentas(): Promise<any> {
        return new Promise((resolve, reject) => {
            const query = `ope-cuentas?filters[id][$eq]=${this.opeCuenta}&populate[ope_empresas][populate]=users_permissions_users`;
            this.coalService.getService(query)
                .subscribe({
                    next: (res: any) => {
                        if (res && res.data) {
                            const usersSet = new Set();
                            const usuariosRegistrados = [];
    
                            res.data.forEach(cuenta => {
                                cuenta.attributes.ope_empresas.data.forEach(empresa => {
                                    empresa.attributes.users_permissions_users.data.forEach(usuario => {
                                        const user = usuario.attributes;
                                        if (!usersSet.has(user.email)) {
                                            usersSet.add(user.email);
                                            usuariosRegistrados.push({
                                                id: usuario.id,
                                                nombre: user.username,
                                                email: user.email
                                            });
                                        }
                                    });
                                });
                            });
    
                            this.usuariosRegistrados = usuariosRegistrados;
                            resolve(usuariosRegistrados);
                        } else {
                            resolve([]);
                        }
                    },
                    error: (error: any) => reject(error)
                });
        });
    }
}
